import { useQuery } from "@tanstack/react-query";
import { LineChart, Line, ResponsiveContainer, YAxis } from "recharts";
import { DOMAIN_RANGE } from "@/lib/chart";
import { http } from "@/lib/data";
import { num, pct } from "@/lib/format";
import { AlertButton } from "@/components/PriceAlert";

export const useQuotes = (group) => useQuery({ queryKey: ["quotes", group], queryFn: () => http.get(`/market/quotes/${group}`).then((r) => r.data), refetchInterval: 60000 });

export const QuoteCard = ({ q, prefix = "", dp = 2 }) => (
  <div data-testid={`quote-${q.symbol.replace(/[^a-zA-Z0-9]/g, "").toLowerCase()}`} className="bg-white rounded-2xl border border-slate-200 p-4 hover:shadow-md transition-shadow">
    <div className="flex items-center gap-2">
      {q.image && <img src={q.image} alt="" className="w-5 h-5" />}
      <p className="text-xs font-semibold text-slate-500 truncate">{q.label}</p>
    </div>
    <p className="font-mono text-lg font-bold mt-1">{prefix}{num(q.price, dp)} {q.unit && q.unit !== "INR" && <span className="text-[10px] font-sans text-slate-400">{q.unit}</span>}</p>
    <p className={`font-mono text-xs font-semibold ${q.change_pct >= 0 ? "text-emerald-600" : "text-red-500"}`}>{pct(q.change_pct)} <span className="text-slate-400 font-sans font-normal">today</span></p>
    {q.inr_note && <p className="text-[11px] text-amber-700 mt-1">{q.inr_note}</p>}
    <AlertButton q={q} />
    {q.spark?.length > 1 && (
      <ResponsiveContainer width="100%" height={40}>
        <LineChart data={q.spark.map((v, i) => ({ i, v }))}><YAxis hide domain={DOMAIN_RANGE} /><Line dataKey="v" stroke={q.change_pct >= 0 ? "#10B981" : "#EF4444"} strokeWidth={2} dot={false} isAnimationActive={false} /></LineChart>
      </ResponsiveContainer>
    )}
  </div>
);

export const QuoteGrid = ({ group, prefix, dp, cols = "md:grid-cols-4" }) => {
  const { data, isLoading } = useQuotes(group);
  return (
    <>
      <div data-testid={`quotes-${group}`} className={`grid grid-cols-2 ${cols} gap-4`}>
        {isLoading ? Array(8).fill(0).map((_, i) => <div key={i} className="h-32 rounded-2xl bg-slate-200/60 animate-pulse" />) : (data?.items || []).map((q) => <QuoteCard key={q.symbol} q={q} prefix={prefix} dp={dp} />)}
      </div>
      <p className="text-xs text-slate-500 mt-3">Source: {data?.source} · auto-refresh every 60s</p>
    </>
  );
};
